import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import { useReclassificationModal } from '../context/ReclassificationModalContext';

const ReclassificationModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useReclassificationModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('Reclassification')}</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default ReclassificationModalHeader;
